// extracted by mini-css-extract-plugin
module.exports = {"cardItem":"shimmer_cardItem__31Q0R","placeholderShimmer":"shimmer_placeholderShimmer__2b49i"};